export const apiConstants = {
  url: "/api/order",
  customer: "/api/customer",
  country: "/api/country",
  orderLine: "/api/orderline",
  doorType: "/api/doortype",
  item: "/api/item",
  wallconnection: "/api/wallconnection",
  frame: "/api/frame",
  tags: "/api/tags",
  edgespacer: "/api/edgespacer",
  favorites: "/api/favorites",
  handbooks: "/api/handbooks",
  orderDocument: "/api/orderdocument"
};
